<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="getData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content search-input-group common-search-formtype">
          <el-form :inline="true" :model="formInline" class="search-content-item" label-width="100px">
            <el-form-item label="是否中奖:">
              <el-select v-model="formInline.draw_status" placeholder="请选择">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="exportAction" class="add-btn" style="float: right;">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        v-loading="loading"
        :data="tableData"
        class="table">
        <el-table-column
          label="时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          label="是否中奖">
          <template slot-scope="scope">
            <div v-if="scope.row.draw_status === 0 && scope.row.draw_status !== null">未中奖</div>
            <div v-if="scope.row.draw_status === 1 && scope.row.draw_status !== null">已中奖</div>
          </template>
        </el-table-column>
        <el-table-column
          label="奖品类型">
          <template slot-scope="scope">
            <div v-if="scope.row.prize_type === 1">实物</div>
            <div v-if="scope.row.prize_type === 2">红包</div>
            <div v-if="scope.row.prize_type === 3">优惠券</div>
            <div v-if="scope.row.prize_type === 4">积分</div>
          </template>
        </el-table-column>
        <el-table-column
          label="奖品">
          <template slot-scope="scope">
            <div v-if="scope.row.prize_type === 1">{{ scope.row.prize_name }}</div>
            <div v-if="scope.row.prize_type === 2">{{ scope.row.prize_money }}元</div>
            <div v-if="scope.row.prize_type === 3" class="link">{{ scope.row.prize_name }}</div>
            <div v-if="scope.row.prize_type === 4">{{ scope.row.prize_money }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="中奖人id">
          <template slot-scope="scope">
            <router-link :to="'/home/model-consumer?id='+ scope.row.customer_id+'&modelId='+ modelId+'&useName=客户'">{{scope.row.customer_id}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          label="联系人">
          <template slot-scope="scope">
            <div v-if="scope.row.receiver_name !== ''">{{ scope.row.receiver_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.receiver_mobile }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address_detail"
          label="邮寄地址">
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { statisticAcivity, exportActivity } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未中奖',
          value: 0
        },
        {
          label: '已中奖',
          value: 1
        }
      ],
      modelId: 0,
      activityID: '',
      formInline: {
        title: '',
        start_date: '',
        end_date: ''
      },
      hide: true,
      loading: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0
    }
  },
  methods: {
    exportAction() {
      exportActivity(this.activityID, { draw_status: this.formInline.draw_status }).then(res => {
        this.download(res)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      statisticAcivity(this.activityID, this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.modelId = res.data.data.model_id
          this.totalCount = res.data.data.count
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.activityID = this.$route.query.id
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
